import { EMPTY, ON_SALE, OFFER_MADE, ITEM_SOLD, FAVORITES, FOLLOWING, VIEW_ALL } from './favNotificationsConstants';

const trackingLabels = {
    [EMPTY]: 'empty state',
    [ON_SALE]: 'item price update',
    [OFFER_MADE]: 'item offer made',
    [ITEM_SOLD]: 'item sold',
    [FAVORITES]: 'recently saved',
    [FOLLOWING]: 'new arrivals',
    [VIEW_ALL]: 'view all'
};

export const getNotificationsDisplayedTrackingObj = ({ types, hasNewEvents }) => ({
    category: 'navigation',
    action: 'header favorites notification displayed',
    label: types.filter(({displayed}) => displayed).map(({type}) => trackingLabels[type]).join('|'),
    value: hasNewEvents ? 1 : 0
});

export const getNotificationClickedTrackingObj = type => ({
    category: 'navigation',
    action: 'header favorites notification clicked',
    label: trackingLabels[type]
});

export const getItemEventLinkClickedTrackingObjs = ({ item, eventType }) => eventType === OFFER_MADE ? [
    {
        category: 'make offer click',
        action: 'header favorites notification',
        label: 'none'
    },
    {
        category: 'ecommerce',
        action: 'add to cart',
        label: item.serviceId
    }
] : [];

export const indicatorShownTrackingObj = () => ({
    category: 'navigation',
    action: 'header favorites notification alert displayed',
    label: 'none'
});



// WEBPACK FOOTER //
// ./src/components/FavNotifications/trackingHelpers.es.js